import UserAll from './UserAll';

export default UserAll;
